export function attributionStartSession(userEmail: string) {
    if (window.Attribution && userEmail) {
        window.Attribution.identify(userEmail, { email: userEmail })
    }
}

export function attributionEndSession() {
    if (window.Attribution) {
        window.Attribution.reset()
    }
}
